import { useEffect } from 'react';
import { useAppStore } from '../store/appStore';

export function useSidebar() {
  const { sidebarOpen, setSidebarOpen, toggleSidebar } = useAppStore();

  /* Close sidebar on ESC */
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && sidebarOpen) setSidebarOpen(false);
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [sidebarOpen, setSidebarOpen]);

  /* Close sidebar on route change (wide screens don't need this but mobile does) */
  const closeSidebar = () => setSidebarOpen(false);

  return { sidebarOpen, toggleSidebar, closeSidebar };
}
